import React, { useEffect, useMemo, useState } from 'react';
import api from '../../api/client';
import {
  Box, Card, CardContent, Divider, Grid,
  Typography, makeStyles
} from '@material-ui/core';
import { toFarsiDigits } from '../../assets/utils';
import SearchField from '../../components/SearchField';
import RequestsModal from './RequestsModal';
import StatsCards from '../../components/contracts/StatsCards';
import ContractCards from '../../components/contracts/ContractCards';
import SortSelect from '../../components/contracts/SortSelect';
import { computeStats, filterRows, sortRows } from '../../components/contracts/boardUtils';

const useStyles = makeStyles(() => ({
  root: { background: '#f1f1f1', flexGrow: 1 },
  container: { maxHeight: '45vh' },
  search: { maxWidth: 420 },
}));

export default function ContractsSupervised() {
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');
  const [openReq, setOpenReq] = useState(false);
  const [selectedContract, setSelectedContract] = useState(null);
  const [query, setQuery] = useState('');
  const [mode, setMode] = useState('all');
  const [sortMode, setSortMode] = useState('name');

  useEffect(() => {
    let cancelled = false;
    const fetchContracts = async () => {
      try {
        setLoading(true);
        setErr('');
        const res = await api.get('/contracts/', { params: { page: 1, page_size: 300 } });
        const data = Array.isArray(res.data) ? res.data : (res.data.results || []);
        if (!cancelled) setRows(data);
      } catch {
        if (!cancelled) setErr('خطا در دریافت قراردادها');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    fetchContracts();
    return () => { cancelled = true; };
  }, []);

  const stats = useMemo(() => computeStats(rows), [rows]);
  // مرتب‌سازی: اول پیمانکار، سپس در قراردادهای هر پیمانکار تاریخِ نزولی
  const sorted = useMemo(() => sortRows(rows, sortMode), [rows, sortMode]);
  const visible = useMemo(() => filterRows(sorted, { query, mode }), [sorted, query, mode]);

  const openDialogFor = (contract) => {
    setSelectedContract(contract);
    setOpenReq(true);
  };

  return (
    <Card elevation={5} className={classes.root}>
      <Box style={{ padding: '6px 4px 0' }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" style={{ gap: 10, marginBottom: 12 }}>
          <Typography variant="h6" style={{ fontWeight: 800, color: '#1a237e' }}>
            قراردادهای تحت نظارت من
          </Typography>
          <Typography variant="body2" style={{ color: '#5a6b8c' }}>
            {toFarsiDigits(visible.length)} قرارداد نمایش داده می‌شود
          </Typography>
        </Box>
      </Box>
      <Divider />
      <CardContent>
        {err && <Typography color="error">{err}</Typography>}
        {loading && <Typography>در حال بارگذاری…</Typography>}

        <StatsCards stats={stats} mode={mode} onModeChange={setMode} />

        <Grid container spacing={2} style={{ marginBottom: 14 }} alignItems="center">
          <Grid item xs={12} md={7}>
            <SearchField
              size="small"
              variant="outlined"
              placeholder="🔍 جستجو در سازمان، شماره، موضوع، پیمانکار ... (همان لحظه)"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              style={{ minWidth: 280, width: '100%', maxWidth: 520, background: '#fff', borderRadius: 8 }}
            />
          </Grid>
          <Grid item xs={12} md={5}>
            <SortSelect value={sortMode} onChange={setSortMode} />
          </Grid>
        </Grid>

        <ContractCards
          rows={visible}
          showConsultant
          sortMode={sortMode}
          onOpenRequests={openDialogFor}
          supervisorLinks
        />
      </CardContent>

      <RequestsModal
        open={openReq}
        onClose={() => setOpenReq(false)}
        contract={selectedContract}
      />
    </Card>
  );
}
